import React, { FC, useState } from 'react';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { BlockType } from '../../../../../config/api/models/Block';
import {
  Button,
  FormControl,
  Message,
  Icons,
  Paragraph,
  TextFieldAdapter,
  validations,
} from '../../../../shared/components';
import AddBlockButtonLarge from './AddBlockButtonLarge';
import { AddBlockButtonProps } from '../../../types';
import AddBlockButton from './AddBlockButton';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { addBlock } from 'src/modules/shared/slices/blocks/api/blocks';

const AddIFrameBlockButton: FC<AddBlockButtonProps> = ({
  bookId,
  pageId,
  viewMode,
  previousBlockId,
  clusterId,
  sectionId,
}) => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const dispatch = useAppDispatch();
  const error = useAppSelector((state) => state.blocks.error);

  const addIFrame = (url: string) => {
    const splitUrl = url.split('://');
    const finalUrl = splitUrl[0] === 'http' || splitUrl[0] === 'https' ? url : `https://${url}`;
    dispatch(
      addBlock({
        bookId,
        pageId,
        payload: {
          type: BlockType.IFRAME,
          title: t(`trajectory.page.blocks.iframe.title`),
          content: finalUrl,
          previous_block_id: sectionId === previousBlockId ? '' : previousBlockId,
          cluster_id: clusterId,
          section_id: sectionId,
        },
      })
    );
  };

  return (
    <>
      {
        {
          emptyPage: (
            <AddBlockButtonLarge
              title={t(`trajectory.page.blocks.iframe.title`)}
              description={t(`trajectory.page.blocks.iframe.description`)}
              icon={Icons.BLOCK_TYPE_IFRAME}
              onClick={() => setDialogOpen(true)}
            />
          ),
          sidebar: <AddBlockButton type={BlockType.IFRAME} onClick={() => setDialogOpen(true)} />,
        }[viewMode]
      }
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby={'add-iframe-form'}
      >
        <Form
          onSubmit={(values: any) => {
            addIFrame(values.url);
            setDialogOpen(false);
          }}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <DialogTitle>{t('trajectory.page.blocks.iframe.form.title')}</DialogTitle>
              <DialogContent>
                <Paragraph>{t('trajectory.page.blocks.iframe.form.intro')}</Paragraph>
                <FormControl label={t('trajectory.page.blocks.iframe.form.url')} id="url" required>
                  <Field name="url" component={TextFieldAdapter} validate={validations(t).isURL} />
                </FormControl>
                {error && <Message type="error">{t(`shared.errors.generic`)}</Message>}
              </DialogContent>
              <DialogActions>
                <Button variant="text" onClick={() => setDialogOpen(false)}>
                  {t('shared.forms.cancel')}
                </Button>
                <Button type="submit">{t('shared.forms.confirm')}</Button>
              </DialogActions>
            </form>
          )}
        />
      </Dialog>
    </>
  );
};

export default AddIFrameBlockButton;
